import {AbstractSearchCore} from "./AbstractSearchCore";
import {AbstractSubscriber} from "./AbstractSubscriber";
import {IFacet} from "./IFacet";
import {IResult} from "./IResult";
import {IFacetFilters} from "./IFacetFilters";

export class FacetFiltersSubscriber extends AbstractSubscriber {
  core: AbstractSearchCore | undefined;
  onFiltersLoadedCallback: (filters: IFacetFilters) => void;
  onFacetsUpdatedCallback: (facets: IFacet[]) => void;

  constructor(
    groupId: string,
    onFiltersLoadedCallback: (filters: IFacetFilters) => void,
    onFacetsUpdatedCallback: (facets: IFacet[]) => void
  ) {
    super(groupId);
    this.onFiltersLoadedCallback = onFiltersLoadedCallback;
    this.onFacetsUpdatedCallback = onFacetsUpdatedCallback;
  }
  public async attached(searchCore: AbstractSearchCore): Promise<void> {
    this.core = searchCore;
    const facetFilters = await searchCore.loadFacetFilters();
    this.onFiltersLoadedCallback(facetFilters);
  }

  detaching(): void {
  }

  public getFacets(): IFacet[] {
    return this.core?.getFacets() || [];
  }

  public updateFacetFilter(facetFilter: string, isSelected: boolean, facetKey: string) {
    this.core?.setFacet({
      name: facetKey,
      options: [{available: true, selected: !isSelected, value: facetFilter}]
    })
  }

  onFacetUpdate(facets: IFacet[]): Promise<void> {
    this.onFacetsUpdatedCallback(facets);
    return Promise.resolve(undefined);
  }

  onResultUpdate(result: IResult): Promise<void> {
    console.log(result);
    return Promise.resolve(undefined);
  }

  onSearchTextUpdate(text: string): Promise<void> {
    console.log(text);
    return Promise.resolve(undefined);
  }
}